import { createAction } from 'redux-starter-kit';
import { get, post } from '../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../domain/requests/RequestActions';
import { addMessage } from '../application/messageUiActions';
import {putCustomerCredit, putCustomerCredits} from "../../domain/credits/customerCreditActions";
import {putOverallBucketBalance} from "../../domain/credits/overallBalanceActions";
import {putBucketBalances} from "../../domain/credits/creditBalanceActions";

/**
 * An action that signifies a new allocation is being started
 */
export const createCredits = createAction('CREATE_CUSTOMER_CREDITS');

/**
 * An action that signifies the new credits are no longer being created.
 */
export const cancelCreateCredits = createAction('CANCEL_CREATE_CUSTOMER_CREDITS');

/**
 * An action that signifies a request to retrieve all customer credit balances for a management company
 */
export const fetchAllCredits = createAction('FETCH_ALL_CUSTOMER_CREDITS');

/**
 * An action that retrieves all customer credit balances for a management company
 */
export function requestAllCreditBalances(manageCompany) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAllCredits().toString()));
    dispatch(fetchAllCredits(requestId));
    try {
      const [balances, balance] = await Promise.all([get('/api/tokens/buckets/customer-balances/' + manageCompany, undefined, {}), get('/api/tokens/buckets/balance/' + manageCompany, undefined, {})]);

      dispatch(putCustomerCredits(balances));
      dispatch(putOverallBucketBalance(balance));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/**
 * An action that signifies a request to retrieve all bucket balances for a management company
 */
export const fetchAllBucketBalances = createAction('FETCH_ALL_BUCKET_BALANCES');

/**
 * An action that retrieves the detailed bucket balances for a management company
 */
export function requestBucketBalances(manageCompany) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAllBucketBalances().toString()));
    dispatch(fetchAllBucketBalances(requestId));
    try {
      const balances = await get('/api/tokens/buckets/balances/' + manageCompany, undefined, {});

      dispatch(putBucketBalances(balances));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/**
 * An Action marking a request to save a new credit allocation
 */
export const saveCreditAllocation = createAction('SAVE_CREDIT_ALLOCATION');

/**
 * An action that saves a new credit allocation to the database
 */
export function requestAddMoreCredit(newCreditObj, manageCompany) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveCreditAllocation().toString()));
    dispatch(saveCreditAllocation(requestId));
    try {
      const saveObject = { userGroupId: newCreditObj.userGroupId, tokenCount: newCreditObj.tokenCount, endDate: newCreditObj.endDate };  //only what needed, rest used below
      await post('/api/tokens/buckets/allocate-customer/' + manageCompany, undefined, saveObject);
      dispatch(putCustomerCredit({ ...newCreditObj, id: newCreditObj.userGroupId, currentBalance: (newCreditObj.currentBalance + newCreditObj.tokenCount) }));   //to update table
      dispatch(addMessage('success', 'itemSaved', { item: newCreditObj.description }));

      const balance = await get('/api/tokens/buckets/balance/' + manageCompany, undefined, {});
      dispatch(putOverallBucketBalance(balance));   //refresh total balance

      dispatch(cancelCreateCredits());
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

